import React, { createContext, useContext, useState } from 'react';

const DirtyStateContext = createContext({
  isDirty: false,
  setIsDirty: (dirty: boolean) => {},
});

export const useDirtyState = () => useContext(DirtyStateContext);

export const DirtyStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [isDirty, setIsDirty] = useState(false);

  return (
    <DirtyStateContext.Provider value={{ isDirty, setIsDirty }}>
      {children}
    </DirtyStateContext.Provider>
  );
};
